import React from 'react';
import { Mail, MessageCircle, HelpCircle } from 'lucide-react';

const Support = () => {
    const colors = {
        primary: '#53354a',
        secondary: '#F5793B',
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <header className="bg-gradient-to-r from-accent2 to-primary py-16 px-8">
                <div className="max-w-6xl mx-auto text-center">
                    <h1 className="text-4xl font-bold mb-4 text-white">Support</h1>
                    <p className="text-xl max-w-2xl mx-auto text-white">We're here to help you get the most out of ALE</p>
                </div>
            </header>

            <section className="py-16 px-8">
                <div className="max-w-4xl mx-auto">
                    <div className="grid md:grid-cols-3 gap-8 mb-16">
                        <div className="bg-white p-8 rounded-lg shadow-md text-center">
                            <div className="inline-flex items-center justify-center w-16 h-16 mb-6 rounded-full" style={{ backgroundColor: colors.secondary }}>
                                <Mail className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="text-xl font-bold mb-3" style={{ color: colors.primary }}>Email Us</h3>
                            <p className="text-gray-600 mb-4">Get in touch with our support team directly.</p>
                            <a href="mailto:support@ale.tours" className="font-semibold hover:underline" style={{ color: colors.secondary }}>
                                support@ale.tours
                            </a>
                        </div>

                        <div className="bg-white p-8 rounded-lg shadow-md text-center">
                            <div className="inline-flex items-center justify-center w-16 h-16 mb-6 rounded-full" style={{ backgroundColor: colors.secondary }}>
                                <MessageCircle className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="text-xl font-bold mb-3" style={{ color: colors.primary }}>Response Time</h3>
                            <p className="text-gray-600">We typically respond within 24 hours during business days.</p>
                        </div>

                        <div className="bg-white p-8 rounded-lg shadow-md text-center">
                            <div className="inline-flex items-center justify-center w-16 h-16 mb-6 rounded-full" style={{ backgroundColor: colors.secondary }}>
                                <HelpCircle className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="text-xl font-bold mb-3" style={{ color: colors.primary }}>FAQs</h3>
                            <p className="text-gray-600">Find quick answers to common questions below.</p>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-md p-8">
                        <h2 className="text-2xl font-bold mb-8" style={{ color: colors.primary }}>Frequently Asked Questions</h2>

                        <div className="space-y-6">
                            <div className="border-b pb-6">
                                <h3 className="text-lg font-semibold mb-2" style={{ color: colors.primary }}>What is ALE?</h3>
                                <p className="text-gray-600">ALE is an AI-powered self-guided tour app that acts as your personal guide. It knows where you are, speaks your language, and lets you explore at your own pace.</p>
                            </div>

                            <div className="border-b pb-6">
                                <h3 className="text-lg font-semibold mb-2" style={{ color: colors.primary }}>Which languages are supported?</h3>
                                <p className="text-gray-600">ALE supports over 50 languages, so you can explore in whichever language you're most comfortable with.</p>
                            </div>

                            <div className="border-b pb-6">
                                <h3 className="text-lg font-semibold mb-2" style={{ color: colors.primary }}>Do I need an internet connection?</h3>
                                <p className="text-gray-600">An internet connection is required for the AI conversation features. We recommend having mobile data or Wi-Fi available during your tour.</p>
                            </div>

                            <div className="border-b pb-6">
                                <h3 className="text-lg font-semibold mb-2" style={{ color: colors.primary }}>How do I delete my account?</h3>
                                <p className="text-gray-600">You can delete your account through the app settings or by visiting the Delete Account page on our website.</p>
                            </div>

                            <div>
                                <h3 className="text-lg font-semibold mb-2" style={{ color: colors.primary }}>How can I report a bug or suggest a feature?</h3>
                                <p className="text-gray-600">Send us an email at <a href="mailto:support@ale.tours" className="font-semibold hover:underline" style={{ color: colors.secondary }}>support@ale.tours</a> with details and we'll get back to you.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Support;
